// extracted by mini-css-extract-plugin
module.exports = {"rulerIcon":"_a6e31e32"};